let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bihbw")).then(() => parcelRequire('aH7r4'));